<template lang="pug">
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width='600px' persistent)
    v-card
      v-card-title.px-4
        div.h6.basic800--text {{ $t('manage_shipping_zones') }}
      v-divider.basic300
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      template(v-else)
        v-card-text.pt-4.px-0.pb-0
          div.c1.primary400--text.mx-4 {{ $t('enable_disable_shipping_zones') }}
          div.mt-4
            template(v-for="(zone, idx) in zones")
              div.d-flex.align-center.py-4.pr-1.pl-4(:key="zone.id")
                div.s1.basic800--text {{ zone.name }}
                v-spacer
                div(@click="!zone.original_enabled ? showDisabledError() : ''")
                  y-switch.mb-n3.mx-0.pa-0(v-model="zone.enabled" @change="updateExcluded(zone)" :disabled="!zone.original_enabled")
              v-divider.basic300
          div.mt-4.py-4.pr-1.pl-4(v-if="orderSettings && showOrderSettingSwitch" :style="`background-color: ${$vuetify.theme.themes[$theme].infoT08}; border-radius: 4px`")
            v-row(no-gutters)
              v-col(cols="7")
                div.p2.info500--text {{ $t('turn_on_local_order') }}
              v-spacer
              v-col.shrink
                y-switch.mb-n3.mx-0.pa-0(v-model="exForm" :color="$vuetify.theme.themes[$theme].info500")
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="saveExcluded()" :loading="isLoading")
          .button-AA-small.basic100--text {{ $t('save') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EditStoreZonesDialog',
  props: ['open', 'company', 'form', 'szones' ],
  data: () => ({
    isFetching: false,
    formdata: {},
    zones: [],
    exZones: [], // Working array
    isLoading: false,
    orderSettings: null
  }),
  mounted () {
    this.fetchForm()
    this.fetchOrderSettings()
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    exForm: {
      get() {
        if (this.orderSettings && this.orderSettings.excluded_forms && this.orderSettings.excluded_forms.length > 0 && this.orderSettings.excluded_forms.filter(f => f === this.form.id).length > 0) {
          return false
        }
        return true
      },
      set(newValue) {
        if (newValue) {
          this.$set(this.orderSettings, 'excluded_forms', this.orderSettings.excluded_forms.filter(f => f !== this.form.id))
        } else {
          if (this.orderSettings.excluded_forms.filter(f => f === this.form.id).length === 0) {
            this.orderSettings.excluded_forms.push(this.form.id)
          }
        }
      }
    },
    showOrderSettingSwitch () {
      if (this.zones.filter(f => f.fulfilment_type.includes('local_delivery') && f.enabled === true).length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchForm () {
      this.isFetching = true
      this.$axios.get(`/forms/${this.form.id}/`)
        .then((response) => {
          this.formdata = response.data
          this.exZones = response.data.excluded_zones
          this.szones.forEach(o => {
            const params = { ...o }
            params.original_enabled = o.enabled
            params.enabled = response.data.excluded_zones.indexOf(o.id) === -1 && o.enabled
            this.zones.push(params)
          })
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchOrderSettings () {
      this.$axios.get(`/oms/${this.company.slug}/`)
        .then((response) => {
          this.orderSettings = response.data
        })
        .catch(() => {})
    },
    updateExcluded(zone) {
      let index = this.exZones.indexOf(zone.id)
      if (zone.enabled && index !== -1) {
        this.exZones.splice(index, 1);
      } else if (!zone.enabled && index === -1) {
        this.exZones.push(zone.id)
      }
    },
    saveExcluded () {
      this.isLoading = true
      let data = {
        excluded_zones: this.exZones
      }
      this.$axios.patch(`/forms/${this.form.id}`, data)
        .then(() => {
          if (this.orderSettings) {
            this.$axios.patch(`/oms/${this.company.slug}/`, { excluded_forms: this.orderSettings.excluded_forms })
              .then(() => {
                this.showModal = false
              })
              .catch(() => {
                this.showMessage(['error', this.$t('error_message.unable_to_update_order')])
              })
              .finally(()=>{
                this.isLoading = false
              })
          } else {
            this.showModal = false
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_update_order')])
        })
        .finally(()=>{
          if (!this.orderSettings) {
            this.isLoading = false
          }
        })
    },
    showDisabledError () {
      this.showMessage(['error', this.$t('error_message.please_enable_at_setup')])
    }
  }
}
</script>

<style scoped>
.message {
  white-space: pre-wrap;
}
</style>

<i18n>
{
  "en": {
    "manage_shipping_zones": "Manage Shipping Zones",
    "enable_disable_shipping_zones": "Enable / disable shipping zones for Yezza Store.",
    "turn_on_local_order": "Turn on local order settings for my Yezza Store"
  },
  "id": {
    "manage_shipping_zones": "Kelola Zona Pengiriman",
    "enable_disable_shipping_zones": "Aktif/nonaktifkan zona pengiriman untuk Yezza Store.",
    "turn_on_local_order": "Aktifkan pengaturan pesanan lokal untuk Yezza Store saya"
  }
}
</i18n>
